import { InjectionToken } from "@angular/core";
import { Observable } from "rxjs";

export const TOKEN_STORAGE_ADAPTER = new InjectionToken<Storage>('TOKEN_STORAGE_ADAPTER');

/**
 * This token will be provided by the AuthModule
 * as the auth module has access to the token and the token contains the SAS.
 */
export const PCP_SHARED_SAS = new InjectionToken<Observable<undefined | string>>('PCP_SHARED_SAS');

/**
 * If true, broadcast event when the user gets logged out to other browser tabs.
 */
export const BROADCAST_USER_LOGOUT = new InjectionToken<boolean>('BROADCASE_USER_LOGOUT');

/**
 * Do not append the auth token to requests to these domains.
 */
export const AUTH_INTERCEPTOR_IGNORE_DOMAINS = new InjectionToken<string[]>('AUTH_INTERCEPTOR_IGNORE_DOMAINS');
